import { TradeDirection } from '~/components/Exchange/types'
import { useTranslation } from 'react-i18next'
import Modal from '~/components/Modal'
import { TokenList } from './components'

export interface TokenListModalProps {
  isOpen: boolean
  onDismiss: () => void
  direction: TradeDirection
}

export const TokenListModal: React.FC<TokenListModalProps> = ({
  isOpen,
  onDismiss,
  direction,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={t('select_token')}
      isOpen={isOpen}
      onDismiss={onDismiss}
      animate={false}
    >
      <TokenList direction={direction} onDismiss={onDismiss} />
    </Modal>
  )
}

export default TokenListModal
